import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { FormikErrors } from 'formik';

import CheckboxField from '~/components/Formik/FormFields/CheckboxField';
import InputField from '~/components/Formik/FormFields/InputField';
import InputFieldMask from '~/components/Formik/FormFields/InputFieldMask';
import { cpfMask, phoneMask } from '~/pages/utils/formikFieldsMask';
import { ObjectLiteral } from '~/types/generics';

const GeneralForm = (props: {
  mailError: string;
  errors: FormikErrors<{
    [x: string]: string | never[];
  }>;
  formField: ObjectLiteral;
}) => {
  const {
    mailError,
    errors,
    formField: {
      fullName,
      email,
      emailContact,
      registration,
      cpf,
      phone1,
      phone2,
      area,
      subArea,
      office,
      specialNeed,
      manager,
    },
  } = props;

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Informações gerais
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <InputField name={fullName.name} label={fullName.label} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            mailError={!!(!errors.email && mailError)}
            name={email.name}
            label={email.label}
            fullWidth
            style={{ borderColor: 'red' }}
          />
          {!errors.email && mailError && (
            <span
              style={{ color: 'red', marginLeft: '12px', fontSize: '12px' }}
            >
              {mailError}
            </span>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={emailContact.name}
            label={emailContact.label}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={registration.name}
            label={registration.label}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputFieldMask
            mask={cpfMask}
            name={cpf.name}
            label={cpf.label}
            placeholder="   .   .   -  "
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputFieldMask
            mask={phoneMask}
            name={phone1.name}
            label={phone1.label}
            placeholder="(  )          "
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputFieldMask
            mask={phoneMask}
            name={phone2.name}
            label={phone2.label}
            placeholder="(  )          "
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField name={area.name} label={area.label} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField name={subArea.name} label={subArea.label} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField name={office.name} label={office.label} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField name={manager.name} label={manager.label} fullWidth />
        </Grid>
        <Grid item xs={12}>
          <CheckboxField
            name={specialNeed.name}
            label={specialNeed.label}
            fullWidth
          />
        </Grid>
        {/* <Grid item xs={12} sm={6}>
          <SelectField
            name={country.name}
            label={country.label}
            data={countries}
            fullWidth
          />
        </Grid> */}
        {/* <Grid item xs={12} sm={6}>
          <MultipleSelect
            name={country.name}
            label={country.label}
            data={countries}
            fullWidth
          />
        </Grid> */}
      </Grid>
    </>
  );
};

export default GeneralForm;
